import { render, staticRenderFns } from "./SurveyDetail.vue?vue&type=template&id=11587fcd"
import script from "./SurveyDetail.vue?vue&type=script&lang=js"
export * from "./SurveyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports